import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IBookmarkRepository } from '../../repositories/interfaces/iBookmarkRepository';
import ResponseError from '../../entities/errors/ResponseError';
import { APIPath } from '@intigral/constant';

export interface IDeleteBookmarkUseCase {
    execute(
        apikey: string,
        profileGuid: string,
        token: string,
        identityToken: string,
        assetId: string,
        paId: string,
        src?: string
    ): Promise<boolean>;
}

export class DeleteBookmarkUseCase implements IDeleteBookmarkUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get deleteBookmark(): IBookmarkRepository {
        return container.resolve<IBookmarkRepository>(DI.REPOSITORIES.IBookmarkRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apikey: string,
        profileGuid: string,
        token: string,
        identityToken: string,
        assetId: string,
        paId: string,
        src?: string
    ): Promise<any> {
        const response = await this.deleteBookmark.deleteBookmark(
            apikey,
            profileGuid,
            token,
            identityToken,
            assetId,
            paId,
            src
        );
        if (response?.data) {
            return true;
        }
        if (response?.error) {
            throw new ResponseError(
                { url: APIPath.BOOKMARK_API },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return false;
    }
}
